/**
 * RewardToast Component
 * Displays animated Floating XP/Coins popups and Level Up celebrations
 */
import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, Trophy, Zap, X } from 'lucide-react';
import { getRankInfo } from '../hooks/useGamification';

export function RewardToast({ reward, onClose }) {
  useEffect(() => {
    if (!reward) return;
    const timer = setTimeout(() => {
      onClose();
    }, 3500);
    return () => clearTimeout(timer);
  }, [reward, onClose]);

  if (!reward) return null;

  const rank = getRankInfo(reward.newLevel);

  return (
    <AnimatePresence>
      <div className="reward-overlay-container">
        {/* Floating Reward Pill */}
        <motion.div
          key={reward.timestamp}
          className="reward-floating-pill"
          initial={{ opacity: 0, y: 20, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -20, scale: 0.8 }}
          transition={{ type: 'spring', stiffness: 400, damping: 25 }}
        >
          <div className="reward-xp-group">
            <Zap size={16} className="text-amber-400" />
            <span className="reward-xp-text">+{reward.earnedXP} XP</span>
            {reward.multiplier > 1.0 && (
              <span className="reward-multiplier-badge">🔥 x{reward.multiplier}</span>
            )}
          </div>

          <div className="reward-divider"></div>

          <div className="reward-coins-group">
            <span>🪙 +{reward.earnedCoins}</span>
          </div>

          <button className="reward-close-btn" onClick={onClose} aria-label="Đóng thông báo thưởng">
            <X size={14} />
          </button>
        </motion.div>

        {/* Level Up Celebration Card */}
        {reward.didLevelUp && (
          <motion.div
            className="level-up-card"
            initial={{ opacity: 0, scale: 0.8, y: 30 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ type: 'spring', stiffness: 350, damping: 20 }}
          >
            <div className="level-up-header">
              <Sparkles size={20} className="sparkle-icon" />
              <span>LEVEL UP!</span>
              <Sparkles size={20} className="sparkle-icon" />
            </div>

            <div className="level-up-body">
              <div className="level-up-icon-wrapper">
                <Trophy size={32} />
              </div>
              <h3 className="level-up-number">Cấp độ {reward.newLevel}</h3>
              <p className="level-up-title">
                {rank.badge} {rank.title}
              </p>
              <p className="level-up-cheer">Xuất sắc! Tiếp tục duy trì phong độ tập trung!</p>
            </div>

            <button className="level-up-btn" onClick={onClose}>
              Tiếp tục nhiệm vụ 🚀
            </button>
          </motion.div>
        )}
      </div>
    </AnimatePresence>
  );
}
